import { render } from "./ClientForm.vue?vue&type=template&id=77c6a31a&scoped=true"
import script from "./ClientForm.vue?vue&type=script&lang=js"
export * from "./ClientForm.vue?vue&type=script&lang=js"

import "./ClientForm.vue?vue&type=style&index=0&id=77c6a31a&scoped=true&lang=css"
import "./ClientForm.vue?vue&type=style&index=1&id=77c6a31a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c6a31a"]])

export default __exports__